<div>
  @if (isActivityValid()) {
    @if (activity.isLoggedActivity) {
      <div class="activity-card" [ngClass]="{ 'last-activity-card': isLast }">
        <ng-container>
          @switch (activity.crmObjectSubtype) {
            @case (ActivityType.Note) {
              <crm-activity-logged-note-v2
                [activity]="activity"
                [ownerUser]="activity.ownerUser"
                [associatedObject]="crmObjectIdentifier()"
              ></crm-activity-logged-note-v2>
            }
            @case (ActivityType.Email) {
              <crm-activity-logged-email-v2
                [activity]="activity"
                [ownerUser]="activity.ownerUser"
                [associatedObject]="crmObjectIdentifier()"
              ></crm-activity-logged-email-v2>
            }
            @case (ActivityType.Call) {
              <crm-activity-logged-call-v2
                [activity]="activity"
                [ownerUser]="activity.ownerUser"
                [associatedObject]="crmObjectIdentifier()"
              ></crm-activity-logged-call-v2>
            }
            @case (ActivityType.Meeting) {
              <crm-activity-logged-meeting-v2
                [activity]="activity"
                [ownerUser]="activity.ownerUser"
                [associatedObject]="crmObjectIdentifier()"
              ></crm-activity-logged-meeting-v2>
            }
            @case (ActivityType.Task) {
              <crm-activity-task-v2
                [activity]="activity"
                (activityChange)="updateActivity($event)"
                [associatedObject]="crmObjectIdentifier()"
                [users]="uniqueUsers$ | async"
                [taskOverdue]="activity | crmIsTaskOverdue"
                [ownerUser]="activity.ownerUser"
              ></crm-activity-task-v2>
            }
            @case (ActivityType.Communication) {
              <crm-activity-logged-communication-v2
                [activity]="activity"
                [ownerUser]="activity.ownerUser"
                [associatedObject]="crmObjectIdentifier()"
              ></crm-activity-logged-communication-v2>
            }
          }
        </ng-container>
      </div>
    } @else {
      <div class="activity-card" [ngClass]="{ 'last-activity-card': isLast }">
        <ng-container>
          @switch (activity.crmObjectSubtype) {
            @case (ActivityType.RecordChange) {
              <crm-activity-record-change
                [activity]="activity"
                [showPrimaryAssociation]="!crmObjectIdentifier().crmObjectId"
              ></crm-activity-record-change>
            }
            @case (ActivityType.Note) {
              <crm-activity-note
                [activity]="activity"
                [associatedObjectId]="crmObjectIdentifier().crmObjectId"
                [objectType]="crmObjectIdentifier().objectType"
              ></crm-activity-note>
            }
            @case (ActivityType.Email) {
              <crm-activity-email
                [activity]="activity"
                [associatedObjectId]="crmObjectIdentifier().crmObjectId"
                [objectType]="crmObjectIdentifier().objectType"
              ></crm-activity-email>
            }
            @case (ActivityType.Call) {
              <crm-activity-call
                [activity]="activity"
                [associatedObjectId]="crmObjectIdentifier().crmObjectId"
                [objectType]="crmObjectIdentifier().objectType"
              ></crm-activity-call>
            }
            @case (ActivityType.Communication) {
              <crm-activity-communication
                [activity]="activity"
                [associatedObjectId]="crmObjectIdentifier().crmObjectId"
                [objectType]="crmObjectIdentifier().objectType"
              ></crm-activity-communication>
            }
            @case (ActivityType.OpportunityChange) {
              <crm-activity-opportunity-updated
                [activity]="activity"
                [showPrimaryAssociation]="!crmObjectIdentifier().crmObjectId"
              ></crm-activity-opportunity-updated>
            }
            @case (ActivityType.Meeting) {
              <crm-activity-meeting
                [cardInfo]="activity"
                [associatedObjectId]="crmObjectIdentifier().crmObjectId"
                [objectType]="crmObjectIdentifier().objectType"
              ></crm-activity-meeting>
            }
          }
        </ng-container>
      </div>
    }
  }
</div>
